(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["news"] = factory();
	else
		root["news"] = factory();
})(this, function() {
return webpackJsonp_name_([7],{

/***/ 21:
/* no static exports found */
/* all exports used */
/*!**************************!*\
  !*** ./styles/news.scss ***!
  \**************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 53:
/* no static exports found */
/* all exports used */
/*!********************************!*\
  !*** ./images/news-all-bg.jpg ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/media/images/news-all-bg.jpg";

/***/ }),

/***/ 74:
/* no static exports found */
/* all exports used */
/*!*****************!*\
  !*** ./news.js ***!
  \*****************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(/*! ./styles/news */ 21);

__webpack_require__(/*! ./images/news-all-bg.jpg */ 53);

var _jquery = __webpack_require__(/*! jquery */ 0);

var _jquery2 = _interopRequireDefault(_jquery);

var _barba = __webpack_require__(/*! barba.js */ 2);

var _barba2 = _interopRequireDefault(_barba);

var _common = __webpack_require__(/*! ./common */ 1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ACTIVE = 'is-active';

// Пепетс какой-то
function newsOn() {
    function init_news() {
        // Открываем новости при загрузке странице
        // function open_news() {
        // let $nav = $('.news-nav__item').first();
        // let $feedsection = $('.news-feed__section').first();
        // let $feeditem = $feedsection.children('.news-feed__item').first();
        // let $contentsection = $('.news-content__section').first();
        // let $contentitem = $contentsection.children('.news-content__item').first();


        // $feedsection.addClass(ACTIVE);
        // $feeditem.addClass(ACTIVE);
        // $contentsection.addClass(ACTIVE);
        // $contentitem.addClass(ACTIVE);
        // $nav.addClass(ACTIVE);
        // }

        // Открываем навигацию на маленьких разрешениях
        (0, _jquery2.default)('.news-sidebar__collapse').click(function () {
            var $sidebar = (0, _jquery2.default)('.news-sidebar');

            if (!$sidebar.hasClass(ACTIVE)) {
                $sidebar.addClass(ACTIVE);
            } else {
                $sidebar.removeClass(ACTIVE);
            }
        });

        // Открываем нужный раздел новостей
        // $('.news-nav__link').click(function(e) {
        //   e.preventDefault();
        //
        //   let $self = $(this);
        //   let tag = $self.data('tag');
        //   let $item = $self.parent();
        //   let $items = $('.news-nav__item');
        //   let $feeds = $('.news-feed__section');
        //   let $feeditems = $('.news-feed__item');
        //   let $sidebar = $('.news-sidebar');
        //
        //   $items.removeClass(ACTIVE);
        //   $feeds.removeClass(ACTIVE);
        //   $feeditems.removeClass(ACTIVE);
        //   $item.addClass(ACTIVE);
        //   $('.news-feed__section[data-tag=' + tag + ']').addClass(ACTIVE).children('.news-feed__item').first().addClass(ACTIVE);
        //
        //   if ($sidebar.hasClass(ACTIVE)) {
        //     $sidebar.removeClass(ACTIVE);
        //   }
        // });

        // Открываем новости по клику из news-feed
        // $('.news-feed__item').click(function() {
        //   let $self = $(this);
        //   let $items = $('.news-feed__item');
        //   let tag = $self.parent().data('tag');
        //   let $contents = $('.news-content__section');
        //   let index = $self.index() - 1;
        //   let $contentitems = $('.news-content__section[data-tag=' + tag + ']').children('.news-content__item');
        //   let $content = $(($contentitems)[index]);
        //
        //   console.log($content);
        //
        //   $items.removeClass(ACTIVE);
        //   $contents.removeClass(ACTIVE);
        //   $contentitems.removeClass(ACTIVE);
        //   $self.addClass(ACTIVE);
        //   $('.news-content__section[data-tag=' + tag + ']').addClass(ACTIVE);
        //   $content.addClass(ACTIVE);
        //   $('.news-content').addClass(ACTIVE);
        // });
        //
        // $('.news-content__collapse').click(function() {
        //   $('.news-content').removeClass(ACTIVE);
        // });

        // open_news();

        var tags = ['company', 'events', 'publications'];

        var $listItem = (0, _jquery2.default)('.news-feed__item');
        var firstNews = $listItem.first();
        var segments = cleanArray(window.location.pathname.split('/'));

        // Если индексная новостей или активен фильтр
        if ((segments[2] === 'news' && !segments[3] || tags.indexOf(segments[3]) !== -1) && segments.length !== 6) {
            firstNews.addClass(ACTIVE);
            ajaxLoadNews(firstNews.attr('data-code'));
        }

        $listItem.on('click', function () {
            $listItem.removeClass(ACTIVE);
            var showNews = (0, _jquery2.default)(this).attr('data-code');
            history.pushState({}, "", showNews);
            (0, _jquery2.default)(this).addClass(ACTIVE);
            ajaxLoadNews(showNews);
        });

        (0, _jquery2.default)('.news-content').on('click', '.news-content__collapse', function () {
            (0, _jquery2.default)('.news-content').removeClass(ACTIVE);
        });
    }

    function cleanArray(array) {
        array.forEach(function (x, y) {
            if (!x) delete array[y];
        });

        return array;
    }

    (0, _jquery2.default)(function () {
        init_news();
    });

    function ajaxLoadNews(news) {
        var $newsContent = (0, _jquery2.default)('.news-content__section');

        _jquery2.default.ajax({
            type: 'POST',
            data: { 'code': news },
            url: '/include/news_ajax.php',

            success: function success(result) {
                $newsContent.empty();
                $newsContent.append(JSON.parse(result).html);
                $newsContent.parent().addClass('is-active');
            }
        });
    }
}

!_common.isFirst || newsOn();

var News = _barba2.default.BaseView.extend({
    namespace: 'company',

    onEnter: function onEnter() {
        //console.log('Новый контейнер готов и прикреплен к dom.')
    },
    onEnterCompleted: function onEnterCompleted() {
        //console.log('Переход закончился.')
        newsOn();
    },
    onLeave: function onLeave() {
        //console.log('Новый переход к новой странице только начался.')
    },
    onLeaveCompleted: function onLeaveCompleted() {
        //console.log('Контейнер был удален из dom.')
    }
});

News.init();

/***/ })

},[74]);
});


// WEBPACK FOOTER //
// js/news.js